import axios from 'axios';
import notification from '../utils/notification';
import { FETCH_PAYMENT_DETAILS } from './types';

const formatPaymentDetails = (paymentDetails) => {
	paymentDetails.paymentDetails = `${paymentDetails.brand} ••••${paymentDetails.last4} ${paymentDetails.exp_month}/${paymentDetails.exp_year}`;
};

export const fetchPaymentDetails = () => async (dispatch) => {
	const res = await axios.get('/api/billing/payment-details');

	formatPaymentDetails(res.data);
	dispatch({ type: FETCH_PAYMENT_DETAILS, payload: res.data });
};

export const updateBillingEmail = (newEmail) => async (dispatch) => {
	try {
		const res = await axios.post('/api/billing/update-email', { newEmail });
		const { title, message, error } = res.data;

		return dispatch(notification(title, message, error));
	} catch (err) {
		return dispatch(
			notification(
				'Error',
				'There was an error updating your settings.',
				true
			)
		);
	}
};

// eslint-disable-next-line import/prefer-default-export
export const updatePaymentMethod = (stripeToken) => async (dispatch) => {
	try {
		const res = await axios.post('/api/billing/update-payment-method', {
			stripeToken
		});

		if (res.data && res.data.error) {
			return {
				error: true,
				message:
					'There was an error updating your payment information. Please refresh the page and try again.'
			};
		}

		const getPayment = await axios.get('/api/billing/payment-details');

		formatPaymentDetails(getPayment.data);

		dispatch({ type: FETCH_PAYMENT_DETAILS, payload: getPayment.data });

		dispatch(
			notification(
				'Success',
				`Updated payment method to card ending in ${getPayment.data.last4}`,
				false
			)
		);

		return { error: false };
	} catch (err) {
		dispatch(
			notification(
				'Error',
				'There was an error updating your payment details.',
				true
			)
		);

		return { error: true };
	}
};



// WEBPACK FOOTER //
// ./src/actions/settings.js